import { FormattedMessage } from "react-intl";

import Button, { LinkButton } from "@atlaskit/button-next/new";
import { ModalBody, ModalFooter } from "@atlaskit/modal-dialog";
import { Text, Stack } from "@atlaskit/primitives-next";

import { SAC_URL } from "@/common/routes/constants";

import { messages } from "../messages";

export const RequestAssistanceModalEmpty = ({
    handleCloseModal
}: {
    handleCloseModal: () => void;
}) => {
    return (
        <>
            <ModalBody>
                <Stack space="space.200">
                    <Text>
                        <FormattedMessage
                            {...messages.requestAssistanceModalEmptyDescription}
                        />
                    </Text>
                </Stack>
            </ModalBody>
            <ModalFooter>
                <Button appearance="subtle" onClick={handleCloseModal}>
                    <FormattedMessage
                        {...messages.requestAssistanceModalCancelButton}
                    />
                </Button>
                <LinkButton
                    appearance="primary"
                    target="_blank"
                    href={`${SAC_URL}/contact`}
                >
                    <FormattedMessage
                        {...messages.requestAssistanceModalEmptyModalRaiseTicketButton}
                    />
                </LinkButton>
            </ModalFooter>
        </>
    );
};
